import { Box } from '@mui/material';
import React from 'react';

import PageHeader from '@/components/PageHeader';

import CurrentGroup from './components/CurrentGroup';
import ChartDialog from './components/CurrentGroup/components/ChartDialog/ChartDialog';
import FunctionRows from './components/FunctionRows';
import GroupMenu from './components/GroupMenu';
import MqttContextProvider from './components/MqttContextProvider';
import { PileCtxProvider } from './components/PileCtxProvider';

const Monitor = () => {
  return (
    <PileCtxProvider>
      <MqttContextProvider>
        <PageHeader
          title="充電樁圖表"
          breadcrumbs={[{ name: '汽車充電樁' }, { name: '充電樁圖表' }]}
        />
        <FunctionRows />
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: '300px 3fr',
            my: '10px',
            height: '69vh',
            gap: '10px',
          }}
        >
          <GroupMenu />
          <CurrentGroup />
          <ChartDialog />
        </Box>
      </MqttContextProvider>
    </PileCtxProvider>
  );
};

export default Monitor;
